import { render, staticRenderFns } from "./shortLinkButtons.vue?vue&type=template&id=67046e17&scoped=true"
import script from "./shortLinkButtons.vue?vue&type=script&lang=js"
export * from "./shortLinkButtons.vue?vue&type=script&lang=js"
import style0 from "./shortLinkButtons.vue?vue&type=style&index=0&id=67046e17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67046e17",
  null
  
)

export default component.exports